import AvgTicket from './AvgTicket';
export default AvgTicket;